
<template>
  <div class="selectNav">
    <div class="navTitle">多款智能产品灵活使用各类业务场景</div>
    <div class="boxItem">
      <div class="leftItem">
        <div class="newTitle">众多硬件自由组合</div>
        <ul>
          <li
            :class="[selectNavIndex == index ? 'select' : '']"
            v-for="(item, index) in selectNav"
            :key="index"
            @click="handleNav(index)"
          >
            <div class="flex">
              <div :class="[selectNavIndex == index ? 'text1 select ' : 'text1']">0{{ index + 1 }}</div>
              <div :class="[selectNavIndex == index ? 'text2 select ' : 'text2']">{{ item.title }}</div>
            </div>

            <img
              :class="[selectNavIndex == index
                    ? 'selectImg selectImg1'
                    : 'selectImg']"
              :src="selectNavIndex == index?'/static/newHomeImg/hardware/icon_select.png':'/static/newHomeImg/hardware/icon_unchecked.png'"
              alt
            />
          </li>
        </ul>
      </div>
      <div class="rightItem">
        <div class="rightHeader">
          <div
            v-if="item.title"
            @click="handleSecond(index)"
            :class="[index==selectSecondIndex?'secondTitle  selectSecond':'secondTitle']"
            v-for="(item, index) in selectNav[selectNavIndex].navTag"
            :key="index"
          >{{ item.title }}</div>
          <div v-else style="height:100px"></div>
        </div>
        <div class="rightBody">
          <div class="bodyText">{{selectNav[selectNavIndex].navTag[selectSecondIndex].text}}</div>
          <img
            :class="[selectNavIndex==2&&selectSecondIndex==1?'showImg circleImg':'showImg']"
            v-if="selectNav[selectNavIndex].navTag[selectSecondIndex].src"
            :src="selectNav[selectNavIndex].navTag[selectSecondIndex].src"
            alt
          />
          <div v-if="selectNavIndex==0&&selectSecondIndex==0" class="re2">
            <div class="imgText1 wei9">超长续航</div>
            <div class="imgText2 wei10">6600MAH锂电池，断电情况下可正常工作48小时</div>
            <div class="imgText1 wei11">密封防水</div>
            <div class="imgText2 wei12">
              防水、防潮、防污、
              易擦洗设计工艺，使用寿命延长
            </div>
            <img
              class="showImg3"
              src="/static/newHomeImg/hardware/01/01/electronicscaleimg_cassicstyle_1.png"
              alt
            />
            <div class="showImgBox3">
              <tag-btn
                :icon="item.icon"
                :title="item.title"
                v-for="(item,index) in  showImgItem2"
                :key="index"
              ></tag-btn>
            </div>
          </div>
          <div v-if="selectNavIndex==0&&selectSecondIndex==1" class="re">
            <div class="imgText1 wei1">销售产品追溯</div>
            <div class="imgText2 wei2">销售订单生成可追溯小，手机可扫描相关用户及商品信息</div>
            <div class="imgText1 wei3">适应恶劣环境</div>
            <div class="imgText2 wei4">
              防油、防虫、防水、
              秤体可浸水
            </div>
            <img
              class="showImg1"
              src="/static/newHomeImg/hardware/01/03/electronicscaleimg_LCDscreen_2.png"
              alt
            />
            <div class="showImgBox">
              <tag-btn
                :icon="item.icon"
                :title="item.title"
                v-for="(item,index) in  showImgItem"
                :key="index"
              ></tag-btn>
            </div>
          </div>
          <div v-if="selectNavIndex==0&&selectSecondIndex==2" class="re1">
            <div class="imgText1 wei5">精准称重</div>
            <div class="imgText2 wei6">
              精准称重，重量
              自动传输
            </div>
            <div class="imgText1 wei7">快捷交易</div>
            <div class="imgText2 wei8">
              支持多种支付
              方式
            </div>
            <img
              class="showImg2"
              src="/static/newHomeImg/hardware/01/02/electronicscaleimg_doublesidedscreen_3.png"
              alt
            />
            <div class="showImgBox1">
              <tag-btn
                :icon="item.icon"
                :title="item.title"
                v-for="(item,index) in  showImgItem1"
                :key="index"
              ></tag-btn>
            </div>
          </div>

          <div v-if="selectNavIndex==2&&selectSecondIndex==0" class="re3">
            <img
            class="showImg g"
           
            src="/static/newHomeImg/img_Verticalinquirymachine.png"
            alt
          />
            <div class="machineBox">
              <div class="machineText" v-for="(item,index) in  machineData"
                :key="index">{{item}}</div>
             
            </div>
          </div>
          <div v-if="selectNavIndex==4&&selectSecondIndex==1" class="infoBox flex">
            <div class="leftInfo">
              <div class="aiTitle">专业智能功能</div>
              <div class="aiInfo" v-for="(item,index) in aiData" :key="index">
                <img
                  style="width:14px;height:10px"
                  src="/static/newHomeImg/hardware/05/img_yes.png"
                  alt
                />
                <div class="aiInfoText">{{item}}</div>
              </div>
            </div>
            <img
              src="/static/newHomeImg/hardware/05/img_passengerflowmeter.png"
              alt
              class="rightImg"
            />
          </div>
          <div v-if="selectNavIndex==5&&selectSecondIndex==0" class="wulianBox">
            <div class="wlText">应用场景</div>
            <div class="wlText1 wl2">冷藏车温湿度控制</div>
            <div class="wlText1 wl3">保温箱温度监控</div>
            <div class="wlText1 wlText2 wl4">冰箱、冷柜温度控制</div>
            <div class="wlText1 wlText2 wl5">楼宇、仓库、实验室等</div>
            <div class="wlInfo">
              <div class="aiTitle">产品特征</div>
              <div class="wlInfo1" v-for="(item,index) in wlData" :key="index">
                <img
                  style="width: 8px;
                        height: 8px;
                        background: #2589FF;
                        border-radius: 50%;
                        margin-right:20px"
                  alt
                />
                <div class="wlInfoText">{{item}}</div>
              </div>
            </div>
            <img
              class="wulianImg"
              src="/static/newHomeImg/hardware/06/img_temperatureandhumiditymeter.png"
              alt
            />
            <img
              class="wulianImg1"
              src="/static/newHomeImg/hardware/06/img_bg_Applicationscenarios.png"
              alt
            />
          </div>
          <div v-if="selectNavIndex==6&&selectSecondIndex==0" class="more">
            <div class="moreImgBox" v-for="(item,index) in moreData" :key="index">
              <img class="bigImg" :src="item.img" alt />

              <div class="tagText">{{item.text}}</div>
            </div>
          </div>
        </div>
        <!-- <infoView :stairIndex="selectNavIndex" :secondIndex="selectSecondIndex" ></infoView> -->
      </div>
    </div>
  </div>
</template>
<script>
import infoView from "./infoView.vue";
import tagBtn from "./btn.vue";
export default {
  components: { infoView, tagBtn },
  methods: {
    handleNav(index) {
      this.selectNavIndex = index;
      this.selectSecondIndex = 0;
    },
    handleSecond(index) {
      this.selectSecondIndex = index;
    }
  },
  data() {
    return {
      machineData: [
        "市场信息",
        "质量检测",
        "市场荣誉",
        "商家公示",
        "私人定制",
        "资讯服务",
        "管理制度",
        "产品追溯",
        "菜价公示"
      ],
      moreData: [
        {
          img: "/static/newHomeImg/hardware/img_cloudprinter.png",
          text: "云打印机"
        },
        {
          img: "/static/newHomeImg/hardware/img_HandheldPOSmachine.png",
          text: "手持pos机"
        },
        {
          img:
            "/static/newHomeImg/hardware/img_Intelligentpatrolinstrument.png",
          text: "智能巡查仪"
        },
        {
          img: "/static/newHomeImg/hardware/img_Barscanner.png",
          text: "条形扫描器"
        }
      ],
      selectNavIndex: 0,
      selectSecondIndex: 0,
      infoIndex: 0,
      aiData: [
        "智能跟踪算法分析行人的行为轨迹，精确计算客流人数及行走方向",
        "支持分类统计人员进入、离开情况",
        "支持实时数据上传和周期上传",
        "邮件报表支持日报表、周报表、月报表和年报表",
        "支持高度过滤",
        "支持内置存储（EMMC）"
      ],
      wlData: [
        "超高稳定性，出货稳定，经过大量实测",
        "双重数据保险机制，确保数据无丢失",
        "外壳IP65设计，高防水性能",
        "多项EMC检测",
        "禁止关机功能，防止人为操作失误",
        "操作便利，一键式操作、即拿即用"
      ],
      showImgItem2: [
        {
          title: "防水",
          icon: "/static/newHomeImg/hardware/01/03/icon_waterproof.png"
        },

        {
          title: "语音通报",
          icon: "/static/newHomeImg/hardware/01/03/icon_voiceannouncements.png"
        },
        {
          title: "超长续航",
          icon: "/static/newHomeImg/hardware/01/03/icon_endurance.png"
        }
      ],
      showImgItem: [
        {
          title: "彩屏",
          icon: "/static/newHomeImg/hardware/01/03/icon_colorscreen.png"
        },
        {
          title: "防水",
          icon: "/static/newHomeImg/hardware/01/03/icon_waterproof.png"
        },
        {
          title: "续航",
          icon: "/static/newHomeImg/hardware/01/03/icon_endurance.png"
        },
        {
          title: "语音通报",
          icon: "/static/newHomeImg/hardware/01/03/icon_voiceannouncements.png"
        }
      ],
      showImgItem1: [
        {
          title: "称重",
          icon: "/static/newHomeImg/hardware/01/02/icon_weigh.png"
        },
        {
          title: "计价",
          icon: "/static/newHomeImg/hardware/01/02/icon_valuation.png"
        },
        {
          title: "收银",
          icon: "/static/newHomeImg/hardware/01/02/icon_cashregister.png"
        },
        {
          title: "支付",
          icon: "/static/newHomeImg/hardware/01/02/icon_payment.png"
        }
      ],
      selectNav: [
        {
          title: "智能防水追溯秤",
          navTag: [
            {
              title: "经典款",
              text: "省时省力，让生意更好做",
              src: ""
            },
            {
              title: "液晶屏",
              text: "高性价比，解决行业普遍难题"
            },
            {
              title: "双面屏",
              text: "全功能模块集成，大大提升经营效率"
            }
          ]
        },
        {
          title: "智能显示屏",
          navTag: [
            {
              title: "数据大屏",
              text: "数据可视化分析，提高决策效率",
              src: "/static/newHomeImg/hardware/02/img_bigdatascreen.png",
              index: 0
            },
            {
              title: "商户信用公示屏",
              text: "信息公式化，透明化",
              src: "/static/newHomeImg/hardware/02/img_publicscreen.png",
              index: 1
            }
          ]
        },
        {
          title: "智能查询机",
          navTag: [
            {
              title: "立式查询机",
              text: "市场数据化，精准化",
              src: "",
              index: 0
            },
            {
              title: "卧式查询机",
              text: "多渠道、多方位服务客户",
              src:
                "/static/newHomeImg/hardware/03/img_horizontalinquirymachine.png",
              index: 1
            }
          ]
        },
        {
          title: "智能检测仪",
          navTag: [
            {
              title: "农残快速检测仪",
              text: "快速筛查无损，数据精确",
              src: "/static/newHomeImg/hardware/04/img_fastdetector.png",
              index: 0
            },
            {
              title: "便携式食品综合分析仪",
              text: "人性化便捷操作，数据准确直观",
              src: "/static/newHomeImg/hardware/04/img_analyzer.png",
              index: 1
            }
          ]
        },
        {
          title: "AI设备",
          navTag: [
            {
              title: "智能监控",
              text: "安全防线，智能守护",
              src:
                "/static/newHomeImg/hardware/05/img_Intelligentmonitoring.png",
              index: 0
            },
            {
              title: "客流仪",
              text: "实施统计，精准计算",

              index: 1
            }
          ]
        },
        {
          title: "物联设备",
          navTag: [
            {
              title: "便携式温湿度仪",
              text: "便捷小巧，简洁不简单",
              index: 0
            }
          ]
        },
        {
          title: "更多",

          index: 1,
          navTag: [
            {
              text: "智能硬件，让市场管理更轻松"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.selectNav .navTitle {
  line-height: 28px;
  height: 31px;
  font-size: 30px;
  text-align: center;
  margin-bottom: 72px;
}
.boxItem {
  width: 1300px;
  display: flex;
  margin: 0 auto;
}
.boxItem .leftItem {
  background-color: red;
  width: 392px;
  height: 684px;
  margin-bottom: 45px;
  background-color: #2589ff;
}

.boxItem .leftItem .newTitle {
  width: 240px;
  height: 31px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 28px;
  margin: 39px 0 31px 29px;
}

.flex {
  display: flex;
}
.boxItem .leftItem ul li {
  height: 80px;
  display: flex;
  justify-content: space-between;
}
.boxItem .leftItem .select {
  color: #fff !important;
}
.boxItem .leftItem .text1 {
  width: 40px;
  height: 30px;
  font-size: 40px;
  font-family: Geometr415 Blk BT;
  font-weight: 900;
  color: #5ca7ff;
  line-height: 28px;
  margin: 26px 34px 26px 31px;
}
.boxItem .leftItem .text2 {
  height: 24px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #84bdff;
  line-height: 28px;
  margin: 26px 0;
}
.boxItem .leftItem .selectImg {
  width: 10px;
  height: 16px;
  margin: 41px 41px 0 0;
}
.boxItem .leftItem .selectImg1 {
  width: 32px;
  height: 32px;
  margin-right: 30px;
  margin-top: 24px;
}

.select {
  background: #50a0ff;
  color: #ffffff;
}
.rightHeader {
  display: flex;
  width: 800px;
  /* justify-content: space-around; */
}
.secondTitle {
  width: 250px;
  margin: 0 16px 0 8px;
  text-align: center;
  line-height: 100px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #c2ddff;
}

.selectSecond {
  color: #fff;

  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  position: relative;
}

.selectSecond::after {
  content: "";
  position: absolute;
  bottom: -11px;
  right: 116px;
  width: 20px;
  height: 20px;
  background-color: #fff;
  transform: rotate(45deg);
}
.rightBody .bodyText {
  margin: 50px 0 0 120px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2c3a46;
  line-height: 22px;
}
.showImg {
  width: 650px;
  /* height: 430px; */
  height: 455px;
  margin: 45px 0 0 120px;
}
.circleImg {
  width: 700px;
  height: 488px;
}
.showImg1 {
  height: 440px;
  width: 760px;
}

.re {
  width: 700px;
  height: 460px;
  margin: 45px 0 0 120px;
  position: relative;
}
.showImgBox {
  position: absolute;
  right: -38px;
  bottom: 50px;
  display: flex;
}

.imgText1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;

  line-height: 28px;
}
.imgText2 {
  width: 127px;

  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: #ffffff;
  line-height: 22px;
}

.wei1 {
  position: absolute;
  left: 230px;
  top: 22px;
}
.wei2 {
  position: absolute;
  left: 230px;
  top: 50px;
}
.wei3 {
  position: absolute;
  left: 380px;
  top: 155px;
  color: #fefeff;
}
.wei4 {
  position: absolute;
  left: 380px;
  top: 180px;
}

.showImg2 {
  height: 400px;
  width: 700px;
}
.showImg3 {
  height: 448px;
  width: 624px;
}

.re1 {
  width: 600px;
  height: 420px;
  margin: 45px 0 0 120px;
  position: relative;
}
.re2 {
  width: 700px;
  height: 300px;
  margin: 45px 0 0 120px;
  position: relative;
}
.re3 {
  /* width: 700px;
  height: 300px; */
  /* margin: 45px 0 0 120px; */
  position: relative;
}
.showImgBox1 {
  width: 700px;
  display: flex;
  position: absolute;
  bottom: -39px;
  left: 0;
  justify-content: space-between;
}
.showImgBox3 {
  position: absolute;
  bottom: -83px;
  right: -60px;
}

.wei5 {
  position: absolute;
  left: 22px;
  top: 100px;
}
.wei6 {
  position: absolute;
  width: 98px;
  height: 37px;
  left: 22px;
  top: 130px;
}
.wei7 {
  position: absolute;

  left: 482px;
  top: 138px;
}
.wei8 {
  width: 84px;
  height: 36px;
  position: absolute;
  left: 482px;
  top: 171px;
}
.wei9 {
  position: absolute;
  left: 207px;
  top: 16px;
}
.wei10 {
  position: absolute;
  left: 207px;
  top: 48px;
}
.wei11 {
  position: absolute;
  left: 369px;
  top: 201px;
  color: #fefeff;
}
.wei12 {
  position: absolute;
  left: 369px;
  top: 230px;
}

.infoBox {
  width: 880px;
  height: 430px;
}

.aiTitle {
  margin: 116px 0 36px 120px;
  width: 120px;
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2589ff;
  line-height: 42px;
}

.aiInfo {
  display: flex;
  align-items: center;
  margin: 4px 0 4px 120px;
}

.aiInfo .aiInfoText {
  width: 209px;
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3d4958;
  line-height: 22px;
}
.rightImg {
  width: 475px;
  height: 460px;
  margin-top: 40px;
}

.wulianBox {
  width: 876px;
  height: 405px;
  position: relative;
}
.wulianImg {
  height: 430px;
  position: absolute;
  left: 120px;
  top: 60px;
  z-index: 1;
}
.wulianImg1 {
  position: absolute;
  left: 330px;
  top: 30px;
  z-index: 2;
}

.wlText {
  width: 72px;
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2589ff;
  line-height: 18px;
  position: absolute;
  left: 344px;
  top: 10px;
}

.wlText1 {
  width: 60px;
  height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 18px;
  text-align: center;
  position: absolute;
  z-index: 3;
}
.wlText2 {
  width: 70px;
}
.wl2 {
  left: 350px;
  top: 82px;
}
.wl3 {
  left: 480px;
  top: 82px;
}
.wl4 {
  left: 605px;
  top: 82px;
}
.wl5 {
  left: 734px;
  top: 82px;
}

.wlInfo {
  position: absolute;
  left: 368px;
  top: 78px;
}
.wlInfo1 {
  display: flex;
  align-items: center;
  margin: 15px 0 15px 120px;
}

.wlInfoText {
  line-height: 14px;
  width: 238px;
  height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3d4958;
}

.more {
  width: 752px;
  height: 472px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 120px;
  margin-top: 30px;
  justify-content: space-between;
  align-content: space-between;
}

.moreImgBox {
  position: relative;
  width: 336px;
  height: 226px;

  /* #ffffff, #6fe9e2 */
  background: linear-gradient(-7deg, #3e4043, #4c4f54);
}
.bigImg {
  width: 191px;
  height: 183px;
  position: absolute;
  left: 88px;
  top: 43px;
}
.tagText {
  width: 100px;
  height: 34px;
  position: absolute;
  background: #2589ff;
  border-radius: 17px 0px 0px 17px;
  right: 0;
  top: 8px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 34px;
  text-align: center;
}

.machineBox {
  position: absolute;
  /* color: red; */
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #00326b;
  line-height: 42px;
  left: 175px;
  top: 16px;
}

.machineText {
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/page/newHomePage/selectNav.vue